(function($) {
  $(document).ready(function(){



    //
    //  MENU TOGGLE
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    var mobileMenuToggleClass = 'menu-toggled';
    var mobileMenuItemEnterClass = 'menu-item-enter';
    var mobileMenuItemStartEnterClass = 'menu-item-start-enter';
    var mobileMenuSocialIconsEnterClass = 'social-icons-enter';

    $('.menu-toggle').click(function(){

      var $siteHeader = $('.site-header');

      // If the menu is showing.
      if ($siteHeader.hasClass( mobileMenuToggleClass )) {
        
        // Close mobile menu.
        closeMobileMenu();

      // If the menu is hidden.
      } else {
        $siteHeader.addClass( mobileMenuToggleClass );

        setTimeout(function() {
          mobileMenuTransition();
        }, 100);
      }
    });


    //
    //  CLOSE MOBILE MENU
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    function closeMobileMenu() {

      var $siteHeader = $('.site-header');

      $siteHeader.removeClass( mobileMenuToggleClass );

      var $mainMenuItem = $('.main-navigation .menu .menu-item');
      $mainMenuItem.removeClass( mobileMenuItemEnterClass );
      $mainMenuItem.removeClass( mobileMenuItemStartEnterClass );

      var $socialIcons = $('.main-navigation .social-icons');
      $socialIcons.removeClass( mobileMenuSocialIconsEnterClass );
    }


    //
    //  MOBILE MENU TRANSITION
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    function mobileMenuTransition() {

      var delayInterval = 100; // in miliseconds.
      var delayTotal = 0;
      var delay = 0;

      var $mainMenuItems = $('.main-navigation .menu > .menu-item');

      // Loop through menu items.
      $mainMenuItems.each(function(i, elem) {
        $(elem).addClass( mobileMenuItemStartEnterClass );
      });

      // Loop through menu items.
      $mainMenuItems.each(function(i, elem) {

        delay = delayInterval * i;

        setTimeout(function() {
          $(elem).addClass( mobileMenuItemEnterClass );
        }, delay);
      });

      delay = delay + delayInterval;

      // Add transition class to social icons.
      setTimeout(function() {
        var $socialIcons = $('.main-navigation .social-icons');
        $socialIcons.addClass( mobileMenuSocialIconsEnterClass );
      }, delay);
    }



    //
    //  HEADER SEARCH TOGGLE
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    $('.site-header .search-field').focus(function() {
      var $siteHeader = $('.site-header');
      var searchFormToggleClass = 'show-search';
      $siteHeader.addClass(searchFormToggleClass);
    });

    $('.site-header .search-toggle').click(function() {
      var $siteHeader = $('.site-header');
      var searchFormToggleClass = 'show-search';
      $siteHeader.removeClass(searchFormToggleClass);
    });
    


    //
    //  MOBILE CHILD NAV TOGGLE
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    (function() {
      var w = $(window).width();
      var showIcon = 'plus';
      var hideIcon = 'minus';

      var expandLink = '<div class="expand"><i class="fa fa-' + showIcon + '"></i></div>';
      $('.site-header .menu-item-has-children > a').append(expandLink);

      $('.site-header .menu-item-has-children .expand').click(function(e) {
        e.preventDefault();
        var parentMenuItem = $(this).closest('.menu-item');
        var subMenu = $(this).closest('.menu-item').find('> .sub-menu');
        subMenu.toggle('fast');
        parentMenuItem.toggleClass('expanded');
      });
    })();
    


    //
    //  SCROLL TO TOP
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    (function() {
      $('.scroll-to-top').click(function(e) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
      });
    })();

    function scrollToTop() {
      var scrollToTopOffset = 400;
      var viewportTop = $(window).scrollTop();
      var scrollToTopToggleClass = 'show-scroll-to-top';

      if (viewportTop >= scrollToTopOffset) {
        $('.scroll-to-top').addClass(scrollToTopToggleClass);
      } else {
        $('.scroll-to-top').removeClass(scrollToTopToggleClass);
      }
    }
    scrollToTop();



    //
    //  PARALLAX
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    var w = $(window).width();

    // Make sure parallax only runs on tablet+.
    if ( w > 768 ) {

      // If the page header has parallax turned on.
      if ( $('.page-header').hasClass('has-parallax-background') ) {

        // Initialise stellar on the window.
        $.stellar({
          horizontalScrolling: false,
          hideDistantElements: false,
        });
      }
    }



    //
    //  STICKY HEADER
    //––––––––––––––––––––––––––––––––––––––––––––––––––
    
    function fixedHeader() {
      var body = $('body');
      var siteHeader = $('.site-header');

      if ( siteHeader.hasClass('header-is-fixed') ) {
        var stickyClass = 'site-header-fixed';
        var stickyToggleHeight = 140;

        var siteHeaderHeight = siteHeader.height();
        var wpadmin = $('#wpadminbar');
        var wpadminHeight = $('#wpadminbar').height();

        // Instantiates a variable for use in positioning the mobile sticky header.
        var stickyHeaderMobileModifier;

        var viewportWidth = $(window).width();

        // The current position of the top of the viewport.
        var viewportTop = $(window).scrollTop();

        //
        //  FULL MENU
        //––––––––––––––––––––––––––––––––––––––––––––––––––

        // If the user's browser is > 768px.
        if (viewportWidth >= 768) {
          // If the user scrolls down past the pre-defined height.
          if (viewportTop >= stickyToggleHeight) {
            siteHeader.addClass(stickyClass);
            // body.css('padding-top', siteHeaderHeight);
            siteHeader.css('top', wpadminHeight);

          // If they haven't scrolled past the pre-defined height...
          } else {
            // If the sticky class exists, remove it.
            if (siteHeader.hasClass(stickyClass)) {
              siteHeader.removeClass(stickyClass);
              // body.css('padding-top', 0);
            } else {
              siteHeader.css('padding-top', 0);
              siteHeader.css('top', wpadminHeight);
              // body.css('padding-top', 0);
            }
          }

        //
        //  MOBILE MENU
        //––––––––––––––––––––––––––––––––––––––––––––––––––

        // If the mobile navigation is showing, adjust the top position of the site header.
        } else if (viewportWidth <= 600) {
          // If the user scrolls down past the pre-defined height.
          if (viewportTop >= stickyToggleHeight) {
            siteHeader.addClass(stickyClass);
          } else {
            if (siteHeader.hasClass(stickyClass)) {
              siteHeader.removeClass(stickyClass);
              // body.css('padding-top', 0);
            }
          }

          if (viewportTop < wpadminHeight) {
            siteHeader.css('top', wpadminHeight - viewportTop);
          } else {
            siteHeader.css('top', 0);
          }

        //
        //  MOBILE MENU (600-768px)
        //––––––––––––––––––––––––––––––––––––––––––––––––––

        } else {
          // If the user scrolls down past the pre-defined height.
          if (viewportTop >= stickyToggleHeight) {
            siteHeader.addClass(stickyClass);
          } else {
            if (siteHeader.hasClass(stickyClass)) {
              siteHeader.removeClass(stickyClass);
              // body.css('padding-top', 0);
            }
          }

          siteHeader.css('top', wpadminHeight);
          body.css('padding-top', siteHeaderHeight);
          body.css('padding-top', 0);
        }
      } // if ( $(siteHeader).hasClass('header-is-sticky') ) {
    }
    fixedHeader();





    //
    //  SCROLL TO ANCHOR ON CLICK
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    (function() {
      var targetID;
      var targetSection;
      var targetSectionTop;
      var sectionOffsetTop = 100;
      var href;
      var hash;

      var targetUrl;
      var targetUrlLastChar;
      var targetUrlLength;
      var currentUrlProtocolDomain; // eg. http://google.com
      var currentUrlProtocolDomainIndex;
      var currentUrlPath; // eg. /contact/

      // If an <a> with an #anchor is clicked which isn't JUST a hash #.
      $('a[href*=#]:not([href=#])').click(function(e) {

        // console.log('A link with a # was clicked');

        // Stop the automatic jump to the anchor.
        e.preventDefault();

        // Get the clicked link's href.
        href = $( this ).attr( 'href' );

        // Grabs everthing before the # of the clicked link.
        targetUrl = href.substr(0, href.indexOf( '#' ));

        // Get the last character of the target URL.
        targetUrlLastChar = targetUrl.substr( targetUrl.length - 1, targetUrl.length );

        // If there's no URL before the hash.
        if ( targetUrl.length === 0 ) {

          // console.log('There\'s no url before the #');
          
          // Grabs everthing after the #.
          targetID = href.substr(href.indexOf( '#' ));

          // Scroll to the anchor.
          scrollToAnchor( targetID );

        // If there is a URL before the hash.
        } else {

          // console.log('There IS a URL before the #');
          // console.log('targetUrl: ' + targetUrl);

          // Get the current URL path.
          currentUrlPath = window.location.pathname;
          // console.log('currentUrlPath: ' + currentUrlPath);

          // Get the protocol (i.e. http://) and domain (i.e. google.com) of the current page.
          currentUrlProtocolDomain = window.location.protocol + '//' + window.location.host;
          // console.log('currentUrlProtocolDomain: ' + currentUrlProtocolDomain);

          // Find the index of the current page's protocol and domain.
          currentUrlProtocolDomainIndex = targetUrl.indexOf( currentUrlProtocolDomain );

          // IF the target URL contains the current page's protocol and domain.
          if ( currentUrlProtocolDomainIndex >= 0 ) {

            // console.log('The target URL contains the protocol and domain of the current page');

            // Remove the protocol and domain (i.e. http://google.com).
            targetUrl = targetUrl.substr( currentUrlProtocolDomain.length, targetUrl.length );
            // console.log('targetUrl: ' + targetUrl);
          }

          // If the target URL isn't found within the path of the current page.
          if ( currentUrlPath.indexOf( targetUrl ) == -1 ) {

            // console.log('The target URL is NOT found within current page');

            // Navigate to the clicked link's URL.
            window.location.href = href;

          // If the target URL IS on the current page.
          } else {

            // Get the character length of the current URL.
            targetUrlLength = targetUrl.length;

            // If the target URL is found within the path of the current page 
            // but there's more in the URL string after the target URL.
            if ( targetUrl.length < currentUrlPath.length ) {

              // console.log('The target URL is NOT on the current page.');

              // Navigate to the clicked link's URL.
              window.location.href = href;

            // If the targetUrl length is the same as the currentUrlPath.
            } else {

              // console.log('The target URL IS on the current page');

              // Grabs everthing before the # of the clicked link.
              targetID = href.substr(href.indexOf( '#' ));

              // Scroll to the anchor.
              scrollToAnchor( targetID );
            }
          }
        }
      });


      //
      //  ON PAGE LOAD
      //––––––––––––––––––––––––––––––––––––––––––––––––––

      // If the page loads with a hash.
      hash = window.location.hash;
      // clog( 'hash: ' + hash );

      // If there is a hash.
      if ( hash ) {

        // Scroll to the hash.
        scrollToAnchor( hash );
      }


      //
      //  SCROLL-TO-ANCHOR
      //––––––––––––––––––––––––––––––––––––––––––––––––––

      function scrollToAnchor( targetID ) {

        // Get the corresponding section by ID.
        targetSection = $( targetID );

        // If there's no element with a matching id attribute.
        if ( targetSection.length === 0 ) {

          // Remove the #.
          targetID = targetID.substr( targetID.indexOf( '#' ) + 1 );

          // Look for an element with a matching name attribute.
          targetSection = $('[name="' + targetID + '"]');
        }

        // If a corresponding section exists.
        if ( targetSection.length > 0 ) {
          
          // Get the position of the targetSection as an integer.
          targetSectionTop = Math.round(targetSection.offset().top);

          // This adds 150px spacing above any section.
          // Otherwise the section title is hidden under the stick header.
          targetSectionTop = targetSectionTop - sectionOffsetTop;

          // Make sure targetSectionTop isn't a negative number.
          if ( targetSectionTop < 0 ) {
            targetSectionTop = 0;
          }
          
          // Scroll to the destination.
          $('html, body').animate({
            scrollTop: targetSectionTop
          }, {
            duration: 'slow'
          });
        }
      } // scrollToAnchor()
    })(); // Scroll to anchor anonymous function





    //
    //  SCROLL FUNCTIONS
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    $(window).scroll(function() {
      fixedHeader();
      scrollToTop();
    }); // End of (window).scroll.



    //
    //  RESIZE FUNCTIONS
    //––––––––––––––––––––––––––––––––––––––––––––––––––

    $(window).resize(function() {
      fixedHeader();
    }); // End of (window).resize.
    

  });
})(jQuery);




//
//  COOKIE FUNCTIONS
//––––––––––––––––––––––––––––––––––––––––––––––––––

// Modified from: http://4rapiddev.com/javascript/jquery-show-popup-once-a-day/

function createCookie( name, value, days ) {
  // Checks for the optional days parameter.
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = '; expires='+date.toGMTString();
  }
  else expires = '';
  document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie( name ) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for(var i=0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie( name ) {
  createCookie(name,'',-1);
}